import * as React from 'react';
import { VariantProps, cva } from 'class-variance-authority';

import clsx from 'clsx';

const cardVariants = cva('', {
  variants: {
    variant: {
      row: 'flex flex-row items-center'
    }
  },
  defaultVariants: {
    variant: 'row'
  }
});

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
};

const Card = React.forwardRef<HTMLDivElement, CardProps>(({ className, ...props }, ref) => {
  return (
    <div
      className={clsx('bg-white dark:bg-neutral-800 rounded-3xl overflow-hidden', className)}
      ref={ref}
      {...props}
    />
  );
});

Card.displayName = 'Card';

export default Card;
